import React from 'react';
import { FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { formatDateToPatternRequested } from '@utils/formatters';
import { MarkerInterface } from '@components/ui/Map/MapContainerType';
import * as Styled from './LocationStyles';

function Location(marker: MarkerInterface) {
  const {
    lastLocation: {
      city: { name: cityName },
      state: { acronym: stateAcronym },
      timestamp,
    },
  } = marker;
  function truncateCityUf(city: string, uf: string) {
    const maxLengthCity = 19;

    if (city.length > maxLengthCity) {
      return `${city.slice(0, maxLengthCity)}... ${uf}`;
    }

    return `${city}, ${uf}`;
  }

  return (
    <FuelFlex defaultProps={{ gap: 'km2' }}>
      <Styled.Pulse color="green" />
      <Styled.WrapperText>
        <FuelTypography weight="bold">
          {truncateCityUf(cityName, stateAcronym)}
        </FuelTypography>
        <FuelTypography
          color="neutral-default"
          size="overline"
          weight="bold"
          spacingTop={2}
        >
          {formatDateToPatternRequested(
            timestamp,
            "'Ás' HH:mm 'em' dd MMM",
          ).toLocaleUpperCase()}
        </FuelTypography>
      </Styled.WrapperText>
    </FuelFlex>
  );
}

export default Location;
